<template>
  <div>
    <div v-if="employee.folder && employee.folder.folder_files.length">
      <abstractTable :columns="filesColumns" :data="employee.folder.folder_files"
                      :classes="'ui very compact left aligned very basic celled table'"
                      :dataPerPage="10" :paginationEnable="true"
                      :paginationFirstPageButtonText="$t('first')"
                      :paginationLastPageButtonText="$t('last')"
                      :paginationNextButtonText="$t('next')"
                      :paginationPervButtonText="$t('previous')"
                      style="padding-top: 20px">

        <template slot="table-column">
          <th width="10%" class="center aligned"> {{ $t('actions') }} </th>
        </template>

        <template slot="table-row-after" slot-scope="props">
          <td class="center aligned">
            <a :href="'http://localhost:3000' + props.row.attachment.url">
              {{ $t('download') }}
            </a>
          </td>
        </template>

      </abstractTable>
    </div>

    <div class="ui placeholder segment" style="margin-bottom: 50px" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        {{ $t('noResumeHasBeenAddedYet') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    employee: { type: Object, required: true }
  },
  computed: {
    filesColumns () {
      return [
        { header: this.$t('name'), fieldName: 'name', show: true }
      ]
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/employees/employee_components/FilesPart.vue